/**
 * Application JavaScript
 * Public-facing application functionality
 */

(function ($) {
    "use strict";

    /* ============================================
       Constants & Configuration
       ============================================ */
    const LOADER_DELAY = 100;
    const TOOLTIP_DELAY = 500;
    const DEBOUNCE_DELAY = 250;
    const THROTTLE_DELAY = 250;
    const FILE_SIZE_THRESHOLD = 102400; // 100KB

    /* ============================================
       DOM Initialization
       ============================================ */
    function initializeDOM() {
        $("body").append(
            '<div id="loader" style="display:none;">' +
            '<div class="progress-inner">' +
            '<p class="transfer-progress fw-lighter text-muted"></p>' +
            '<div class="progress">' +
            '<div class="progress-bar progress-bar-striped progress-bar-animated"></div>' +
            "</div>" +
            "</div>" +
            "</div>" +
            '<div class="modal fade" id="modal" tabindex="-1" data-bs-focus="false" data-bs-backdrop="static" data-bs-keyboard="false">' +
            '<div class="modal-dialog modal-dialog-centered">' +
            '<div class="modal-content border-0 rounded-0">' +
            '<div class="text-center m-5"><div class="spinner-border" role="status"></div></div>' +
            "</div>" +
            "</div>" +
            "</div>"
        );
    }

    /* ============================================
       Modal Management
       ============================================ */
    function initializeModals() {
        // Handle hash-based modal loading
        if (window.location.hash.substring(1, 6) === "modal") {
            $("#modal .modal-content").load(
                "/m/" + window.location.hash.substring(7),
                function () {
                    $(document).off("focusin.modal");
                }
            );
            setTimeout(() => {
                $("#modal").modal("show");
            }, LOADER_DELAY);
        }

        // Modal show event
        $("body").on("show.bs.modal", "#modal", function (e) {
            var target = $(e.relatedTarget);
            if (typeof e.relatedTarget !== "undefined") {
                if (target.data("modal-size")) {
                    $("#modal .modal-dialog")
                        .addClass("modal-" + target.data("modal-size"));
                }
                $("#modal .modal-content").load("/m/" + target.data("link"), function () {
                    window.location.hash = "modal/" + target.data("link");
                });
            }
        });

        // Modal hidden event
        $("body").on("hidden.bs.modal", "#modal", function (e) {
            $("#modal .modal-content").html(
                '<div class="text-center m-5"><div class="spinner-border" role="status"></div></div>'
            );
            $("#modal .modal-dialog").removeClass("modal-sm modal-lg modal-xl");
            history.replaceState(null, null, " ");
        });
    }

    /* ============================================
       Action Endpoint Handler
       ============================================ */
    function initializeActionEndpoints() {
        $("body").on("click", '[data-action-endpoint]', function (e) {
            e.preventDefault();
            let $this = $(this);
            let endpoint = $this.data("action-endpoint");
            let payload = $this.data("payload");
            let question = $this.data("question");
            let button = $this.data("button");

            Swal.fire({
                title: strings.areYouSure,
                text: question,
                icon: "question",
                showCancelButton: true,
                showLoaderOnConfirm: true,
                backdrop: true,
                cancelButtonText: strings.cancel,
                confirmButtonText: button,
                allowOutsideClick: () => !swal.isLoading(),
                preConfirm: () => {
                    Swal.getCancelButton().setAttribute("disabled", "");
                    return $.ajax({
                        method: "POST",
                        url: "/a/" + endpoint,
                        data: payload,
                    })
                        .then((response) => {
                            return response;
                        })
                        .catch((error) => {
                            Swal.getCancelButton().removeAttribute("disabled");
                            swal.showValidationMessage(`${error}`);
                        });
                },
            }).then(function (result) {
                if (result.isConfirmed) {
                    Swal.fire({
                        icon: "success",
                        title: result.value.title,
                        html: result.value.body ? result.value.body : null,
                        timer: result.value.timer ? result.value.timer : false,
                        timerProgressBar: true,
                        didOpen: (s) => {
                            s.addEventListener("mouseenter", Swal.stopTimer);
                            s.addEventListener("mouseleave", Swal.resumeTimer);
                        },
                    }).then(function () {
                        history.replaceState(null, null, " ");
                        location.reload();
                    });
                }
            });
        });
    }

    /* ============================================
       Form Validation
       ============================================ */
    function initializeFormValidation() {
        $(document).on("click", "a[data-confirm]", function (e) {
            e.preventDefault();
            let $this = $(this);
            Swal.fire({
                icon: "question",
                title: strings.areYouSure,
                text: $this.data("confirm"),
                showCancelButton: true,
                focusConfirm: false,
                cancelButtonText: strings.cancel,
                confirmButtonText: strings.yes,
                allowOutsideClick: false,
            }).then(function (result) {
                if (result.isConfirmed) {
                    window.location.href = $this.attr("href");
                }
            });
        });
    }

    /* ============================================
       On-Page Search
       ============================================ */
    function initializeOnPageSearch() {
        $(document).on("input", ".on-page-search", debounce(function () {
            let $this = $(this);
            let val = $this.val().toLowerCase();
            let item = $this.data("item");

            $("." + item).each(function () {
                let textContent = $(this).text().toLowerCase();
                let searchData = $(this).data("search");
                let searchDataContent = searchData ? searchData.toLowerCase() : "";

                if (textContent.indexOf(val) === -1 && searchDataContent.indexOf(val) === -1) {
                    $(this).hide();
                } else {
                    $(this).show();
                }
            });
        }, DEBOUNCE_DELAY));
    }

    /* ============================================
       Report Menu
       ============================================ */
    function initializeReportMenu() {
        $(document).on("shown.bs.collapse", "#reportMenu", function (e) {
            $("body").addClass("overflow-hidden");
            $('.report-menu').addClass("menu-open");
        });

        $(document).on("hidden.bs.collapse", "#reportMenu", function (e) {
            $("body").removeClass("overflow-hidden");
            $('.report-menu').removeClass("menu-open");
        });
    }

    /* ============================================
       Utility Functions
       ============================================ */
    function fileSizeNice(x) {
        if (x > 1048576) {
            return (x / 1048576).toFixed(1) + "Mb";
        }
        if (x === 1024) {
            return "1Mb";
        }
        return (x / 1024).toFixed(1) + "Kb";
    }

    function isJson(str) {
        try {
            return JSON.parse(str);
        } catch (e) {
            return false;
        }
    }

    function throttle(fn, freq) {
        var frequency = freq !== undefined ? freq : THROTTLE_DELAY,
            last,
            timer;

        return function () {
            var that = this,
                now = +new Date(),
                args = arguments;

            if (last && now < last + frequency) {
                clearTimeout(timer);
                timer = setTimeout(function () {
                    last = undefined;
                    fn.apply(that, args);
                }, frequency);
            } else {
                last = now;
                fn.apply(that, args);
            }
        };
    }

    function debounce(func, freq) {
        var frequency = freq !== undefined ? freq : DEBOUNCE_DELAY,
            inDebounce;
        return function () {
            let context = this;
            let args = arguments;
            clearTimeout(inDebounce);
            inDebounce = setTimeout(function () {
                func.apply(context, args);
            }, frequency);
        };
    }

    /* ============================================
       Chart/Graph Initialization
       ============================================ */
    let graphDynamic = [];
    let graphLabels = [];

    function initializeGraphs() {
        Chart.register(ChartjsPluginStacked100.default);
        Chart.register(ChartDataLabels);
        if (typeof ChartDeferred !== "undefined") {
            Chart.register(ChartDeferred);
        }
        if (typeof ChartWordCloud !== "undefined") {
            Chart.register(ChartWordCloud.WordCloudController, ChartWordCloud.WordElement);
        }
        Chart.defaults.font.family = "Ubuntu, system-ui, -apple-system, sans-serif";

        $("canvas.graph").each(function (i) {
            let $graph = $(this);
            var type = $graph.data("type") ?? "bar";
            let data = $graph.data("data");
            let colors = $graph.data("colors") || {};

            // jQuery's .data() should automatically parse JSON from data attributes
            // But if it's still a string, try to parse it manually
            if (typeof data === "string") {
                try {
                    data = JSON.parse(data);
                } catch (e) {
                    // If parsing fails, try getting the raw attribute and parsing that
                    const rawAttr = $graph.attr("data-data");
                    if (rawAttr) {
                        try {
                            data = JSON.parse(rawAttr);
                        } catch (e2) {
                            console.warn("Failed to parse graph data JSON:", e2, "Raw attribute length:", rawAttr ? rawAttr.length : 0);
                            data = null;
                        }
                    } else {
                        data = null;
                    }
                }
            }

            // Check if this is a new graph piece type (has raw table data)
            const firstRowIsHeader = $graph.data("first-row-is-header") === true || $graph.data("first-row-is-header") === "true";
            const columnTypes = $graph.data("column-types") || {};
            const isNewGraphType = Array.isArray(data) && data.length > 0 && Array.isArray(data[0]);

            if (isNewGraphType) {
                // Handle new graph piece type
                initializeNewGraphPiece($graph, i, type, data, firstRowIsHeader, columnTypes);
                return;
            }

            // Original graph initialization for existing format
            // Validate data structure before processing
            if (!data || typeof data !== "object" || Array.isArray(data)) {
                console.warn("Invalid graph data format for old graph type, skipping:", i);
                return;
            }

            let groups = Object.keys(data);
            if (!groups || groups.length === 0) {
                console.warn("No groups found in graph data, skipping:", i);
                return;
            }

            if (!data[groups[0]] || typeof data[groups[0]] !== "object") {
                console.warn("Invalid first group data, skipping:", i);
                return;
            }

            let datasetLabels = Object.keys(data[groups[0]]);
            if (!datasetLabels || datasetLabels.length === 0) {
                console.warn("No dataset labels found, skipping:", i);
                return;
            }

            if (!data[groups[0]][datasetLabels[0]] || typeof data[groups[0]][datasetLabels[0]] !== "object") {
                console.warn("Invalid dataset data structure, skipping:", i);
                return;
            }

            let labelSet = Object.keys(colors).reverse();
            let stacked = $graph.data("stacked") ?? false;
            let suggestedMax = $graph.data("suggested-max") ?? 100;
            let rangeSlider = $graph.data("range-slider") ?? true;
            let visibleLabelCount = $graph.data("visible-label-count") ?? 3;
            let datasetToggle = $graph.data("dataset-toggle-map") ?? false;
            let aspectRatio = $graph.data("aspect-ratio") ?? null;
            let barPercentage = $graph.data("bar-percentage") ?? 0.95;
            let categoryPercentage = $graph.data("category-percentage") ?? 1;
            let labelPrefix = $graph.data("label-prefix") ?? "data";
            let indexAxis = $graph.data("index-axis") ?? "y";
            let yDirection = $graph.data("y-direction") ?? false;
            let xDirection = $graph.data("x-direction") ?? false;
            let showGrid = $graph.data("show-grid") === true || $graph.data("show-grid") === "true";
            let graphDatasets = {};
            graphLabels[i] = Object.keys(data[groups[0]][datasetLabels[0]]).reverse();

            Object.keys(data).forEach(function (groupKey) {
                let microset = [];
                Object.keys(data[groupKey]).forEach(function (key) {
                    microset.push({
                        label: key,
                        data: Object.values(data[groupKey][key]).reverse(),
                        backgroundColor: colors[key],
                        stack: stacked ? 'combined' : key,
                        fill: type === "line" ? false : 'origin',
                        borderColor: type === "line" ? colors[key] : false,
                        tension: 0.4
                    });
                });
                graphDatasets[groupKey] = microset;
            });

            graphDynamic[i] = new Chart($graph[0], {
                type: type,
                data: {
                    labels: stacked ? graphLabels[i] : labelSet,
                    datasets: graphDatasets[groups[0]]
                },
                options: {
                    animation: {
                        duration: 500,
                    },
                    indexAxis: indexAxis,
                    responsive: true,
                    devicePixelRatio: Math.max(window.devicePixelRatio || 2, 3),
                    aspectRatio: aspectRatio,
                    categoryPercentage: categoryPercentage,
                    barPercentage: barPercentage,
                    plugins: {
                        stacked100: {
                            enable: stacked,
                            precision: 1
                        },
                        datalabels: {
                            color: () => '#FFFFFF',
                            display: 'auto',
                            clip: true,
                            formatter: (_value, context) => {
                                const data = context.chart.data;
                                const { datasetIndex, dataIndex } = context;
                                return stacked
                                    ? (data.calculatedData[datasetIndex][dataIndex] > 0
                                        ? labelPrefix + data.calculatedData[datasetIndex][dataIndex]
                                        : '')
                                    : (labelPrefix + new Intl.NumberFormat('tr-TR').format(_value));
                            },
                        },
                        legend: {
                            labels: {
                                usePointStyle: true,
                            },
                            display: true,
                        },
                    },
                    scales: {
                        x: {
                            stacked: stacked,
                            grid: {
                                display: showGrid,
                            },
                            ticks: {
                                display: !stacked
                            },
                            border: {
                                display: !stacked
                            },
                            suggestedMax: suggestedMax,
                            reverse: xDirection,
                        },
                        y: {
                            display: indexAxis === "x" ? false : true,
                            stacked: stacked,
                            reverse: yDirection,
                            grid: {
                                display: showGrid
                            },
                            ticks: {
                                callback: function (value, index) {
                                    const val = stacked ? graphLabels[i][value] : labelSet[index];
                                    return val?.length > 10 ? val.substring(0, 30) + '...' : val;
                                },
                                padding: 0
                            }
                        },
                    },
                },
            });

            var $actionBox = $('<div class="action-box mb-1"></div>');
            $graph.before($actionBox);
            graphDynamic[i].data.labels = graphLabels[i].slice(0, visibleLabelCount);
            graphDynamic[i].update();

            var $btnGroup = $('<div class="d-flex w-100 flex-wrap justify-content-start"></div>');
            $actionBox.append($btnGroup);

            if (groups.length > 1) {
                var $selectBox = $(
                    '<select class="form-select form-select-sm filter-toggler rounded-0 ' +
                    (datasetToggle ? 'w-auto' : '') + '" data-graph="' + i + '"/>'
                );
                groups.forEach((group, index) => {
                    if (graphDatasets[group].length > 0) {
                        $selectBox.append(
                            '<option ' + (index === 0 ? 'selected' : '') +
                            ' value="' + group + '" data-group-data=\'' +
                            JSON.stringify(graphDatasets[group]) + '\' >' + group + '</option>'
                        );
                    } else {
                        $selectBox.append('<optgroup label="' + group + '"/>');
                    }
                });
                $btnGroup.append($selectBox);
            }

            if (datasetToggle) {
                $btnGroup.append('<div class="ms-auto"/>');
                Object.entries(datasetToggle).forEach(function (gt) {
                    $btnGroup.append(
                        '<button class="btn btn-sm mx-1 btn-outline-secondary rounded-0" ' +
                        'data-graph="' + i + '" data-dataset-toggle="' + gt[1] + '">' +
                        gt[0] + '</button>'
                    );
                });
            }

            if (graphLabels[i].length > 1 && rangeSlider) {
                let $ticks = $(
                    '<div class="ticks d-flex justify-content-between" ' +
                    'style="margin-top:-0.35rem;padding:0rem 0.45rem 1rem 0.45rem;"/>'
                );
                graphLabels[i].forEach((label, ix, arr) => {
                    if (arr.length - 1 === ix || ix === 0) {
                        $ticks.prepend('<span>' + arr[ix] + '</span>');
                    } else {
                        $ticks.prepend('<span/>');
                    }
                });

                let $ranger = $(
                    '<input type="range" class="form-range mt-2" data-graph="' + i +
                    '" min="-' + graphLabels[i].length + '" value="-' + visibleLabelCount +
                    '" max="-1" step="1" data-bs-toggle="tooltip" data-bs-placement="top" ' +
                    'title="Zaman Serisi">'
                );
                let $rangeWrapper = $('<div class="px-3 pb-4"/>');
                $rangeWrapper.append($ranger);
                $rangeWrapper.append($ticks);
                $graph.after($rangeWrapper);
            }
        });

        // Graph range slider handler
        $(document).on('input', 'input[data-graph]', function () {
            let $this = $(this);
            let graph = $this.data("graph");
            if (graphDynamic[graph] && graphLabels[graph]) {
                graphDynamic[graph].data.labels = graphLabels[graph].slice(0, -$this.val());
                graphDynamic[graph].update();
            }
        });

        // Graph filter toggler handler
        $(document).on('change', '.filter-toggler', function () {
            let $this = $(this);
            var $optionSelected = $this.find("option:selected");
            let graph = $this.data("graph");
            let groupData = $optionSelected.data("group-data");

            if (graphDynamic[graph] && groupData && Array.isArray(groupData)) {
                for (let i = 0; i < graphDynamic[graph].data.datasets.length; i++) {
                    if (groupData[i] && groupData[i].data) {
                        graphDynamic[graph].data.datasets[i].data = groupData[i].data;
                    }
                }
                graphDynamic[graph].update();
            }
        });

        // Dataset toggle handler
        $(document).on('click', '[data-dataset-toggle]', function () {
            let $this = $(this);
            let graph = $this.data("graph");
            if (graphDynamic[graph]) {
                const toggleData = $this.data("dataset-toggle");
                if (toggleData && typeof toggleData === "string") {
                    toggleData.split(',').forEach(function (toggleble) {
                        let meta = graphDynamic[graph].getDatasetMeta(parseInt(toggleble));
                        if (meta) {
                            meta.hidden = !meta.hidden;
                        }
                    });
                }
                $this.toggleClass("active");
                graphDynamic[graph].update();
            }
        });
    }

    // Initialize new graph piece type (from graph editor)
    function initializeNewGraphPiece($graph, index, chartType, rawData, firstRowIsHeader, columnTypes) {
        const Utils = window.GraphUtils || {};
        const colors = $graph.data("colors") || {};

        if (!rawData || !Array.isArray(rawData) || rawData.length === 0) {
            console.warn("Invalid or empty graph data for chart:", chartType, "Skipping chart creation.");
            return;
        }

        if (!Utils.transformData) {
            console.error('GraphUtils not available');
            return;
        }

        let transformed;
        transformed = Utils.transformData(chartType, rawData, firstRowIsHeader, columnTypes, colors);

        if (!transformed || !transformed.datasets || transformed.datasets.length === 0) {
            console.warn("Failed to transform graph data for chart:", chartType);
            return;
        }

        const xAxisMin = $graph.data("x-axis-min");
        const xAxisMax = $graph.data("x-axis-max");
        const xAxisLabel = $graph.data("x-axis-label") || "";
        const yAxisMin = $graph.data("y-axis-min");
        const yAxisMax = $graph.data("y-axis-max");
        const yAxisLabel = $graph.data("y-axis-label") || "";
        const title = $graph.data("title") || "";
        const subtitle = $graph.data("subtitle") || "";
        const stacked = $graph.data("stacked") === true || $graph.data("stacked") === "true";
        const stackTo100 = chartType.includes("stacked-100");
        const showLabels = $graph.data("show-labels") !== false && $graph.data("show-labels") !== "false";
        const showGrid = $graph.data("show-grid") === true || $graph.data("show-grid") === "true";
        const type = Utils.getChartJsType ? Utils.getChartJsType(chartType) : "bar";

        // Font sizes
        const fontSizes = $graph.data("font-sizes") || {};
        const fontSizeTitle = parseInt(fontSizes.title) || 16;
        const fontSizeSubtitle = parseInt(fontSizes.subtitle) || 14;
        const fontSizeLegend = parseInt(fontSizes.legend) || 12;
        const fontSizeLabel = parseInt(fontSizes.label) || 12;
        const fontSizeTooltip = parseInt(fontSizes.tooltip) || 12;
        const isStacked = (Utils.isStacked && Utils.isStacked(chartType)) || chartType.includes("stacked");
        const isArea = (Utils.isArea && Utils.isArea(chartType)) || (chartType === "area" || chartType === "stacked-area" || chartType === "stacked-100-area");
        const aspectRatio = $graph.data("aspect-ratio") || "auto";

        if (transformed && transformed.datasets) {
            const defaultColors = [
                "#FF6384", "#36A2EB", "#FFCE56", "#4BC0C0", "#9966FF",
                "#FF9F40", "#FF6384", "#C9CBCF", "#4BC0C0", "#FF6384"
            ];
            const getDefaultColor = Utils.getDefaultColor || ((idx) => defaultColors[idx % defaultColors.length]);

            if (chartType === "pie" && transformed.labels && transformed.datasets[0] && !transformed.datasets[0].backgroundColor) {
                transformed.datasets[0].backgroundColor = transformed.labels.map((label, idx) =>
                    (colors && colors[label]) || getDefaultColor(idx)
                );
            } else {
                transformed.datasets.forEach((ds, idx) => {
                    if (!ds.backgroundColor) {
                        const color = (colors && colors[ds.label]) || getDefaultColor(idx);
                        ds.backgroundColor = color;
                        if (chartType === "line" || isArea) ds.borderColor = color;
                    }
                });
            }
        }

        if (isStacked || chartType === "stacked-100-area") {
            transformed.datasets.forEach(ds => ds.stack = "combined");
        }

        if (isArea) {
            transformed.datasets.forEach(ds => ds.fill = true);
        }

        if (chartType === "line-column" && columnTypes) {
            transformed.datasets.forEach((ds, idx) => {
                const colType = columnTypes[idx + 1];
                if (colType === "column") ds.type = "bar";
                else if (colType === "line") ds.type = "line";
            });
        }

        const aspectRatioValue = Utils.calculateAspectRatio ? Utils.calculateAspectRatio(aspectRatio) : null;
        const parseAxisValue = (val) => val ? parseFloat(val) : undefined;

        // Store original data for stacked 100% charts before plugin transforms it
        const originalDataForStacked100 = (stackTo100 || chartType === "stacked-100-area") ?
            transformed.datasets.map(ds => [...(ds.data || [])]) : null;

        // Datalabels formatter
        const formatDataLabel = (value, context) => {
            if (value === null || value === undefined || isNaN(value)) return "";
            if (stackTo100 || chartType === "stacked-100-area") {
                // For stacked 100%, show percentages without % sign
                if (originalDataForStacked100) {
                    const datasetIndex = context.datasetIndex;
                    const dataIndex = context.dataIndex;
                    if (originalDataForStacked100[datasetIndex] && originalDataForStacked100[datasetIndex][dataIndex] !== undefined) {
                        const originalValue = originalDataForStacked100[datasetIndex][dataIndex];
                        // Skip if original value is NaN (empty row)
                        if (isNaN(originalValue)) {
                            return "";
                        }
                        // Get original values from all datasets at this dataIndex
                        const allOriginalValues = originalDataForStacked100.map(ds => {
                            const rawValue = ds[dataIndex];
                            // Return NaN if the value is NaN, don't convert to 0
                            if (rawValue === null || rawValue === undefined || rawValue === "") {
                                return NaN;
                            }
                            const numValue = typeof rawValue === "number" ? rawValue : parseFloat(rawValue);
                            return isNaN(numValue) ? NaN : numValue;
                        });
                        // Filter out NaN values for total calculation
                        const validValues = allOriginalValues.filter(val => !isNaN(val));
                        const total = validValues.reduce((sum, val) => sum + val, 0);
                        if (total > 0 && !isNaN(allOriginalValues[datasetIndex])) {
                            const percentage = ((allOriginalValues[datasetIndex] / total) * 100);
                            return new Intl.NumberFormat("tr-TR", {
                                maximumFractionDigits: 0
                            }).format(percentage);
                        }
                    }
                }
                // Fallback to current value if calculation fails
                const numValue = typeof value === "number" ? value : parseFloat(value);
                if (!isNaN(numValue)) {
                    return new Intl.NumberFormat("tr-TR", {
                        maximumFractionDigits: 0
                    }).format(numValue);
                }
            }
            const numValue = typeof value === "number" ? value : parseFloat(value);
            if (isNaN(numValue)) return "";
            return new Intl.NumberFormat("tr-TR", {
                maximumFractionDigits: numValue % 1 === 0 ? 0 : 2
            }).format(numValue);
        };

        const config = {
            type: type,
            data: transformed,
            options: {
                responsive: true,
                maintainAspectRatio: aspectRatio !== "auto",
                devicePixelRatio: Math.max(window.devicePixelRatio || 2, 3),
                layout: {
                    padding: {
                        top: 10,
                        right: 10,
                        bottom: 10,
                        left: 10
                    }
                },
                animation: { duration: 500 },
                plugins: {
                    title: { display: !!title, text: title, align: "start", color: "#b71c1c", font: { size: fontSizeTitle, weight: "bold" } },
                    subtitle: { display: !!subtitle, text: subtitle, align: "start", color: "#b71c1c", font: { size: fontSizeSubtitle } },
                    legend: { display: type !== "wordcloud" && type !== "wordCloud", position: "bottom", labels: { usePointStyle: true, font: { size: fontSizeLegend } } },
                    tooltip: { enabled: true, bodyFont: { size: fontSizeTooltip }, titleFont: { size: fontSizeTooltip } },
                    datalabels: {
                        display: showLabels && (type === "bar" || type === "line" || type === "pie") && typeof ChartDataLabels !== "undefined",
                        anchor: "center",
                        align: "center",
                        color: "#000000",
                        backgroundColor: null,
                        borderRadius: 0,
                        padding: 0,
                        font: { size: fontSizeLabel, weight: "bold" },
                        formatter: type === "pie" ? (value, context) => {
                            const total = context.dataset.data.reduce((a, b) => a + b, 0);
                            const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : "0.0";
                            return percentage + "%";
                        } : formatDataLabel,
                        clip: true,
                        clamp: true,
                        offset: 0
                    },
                    stacked100: (stackTo100 || chartType === "stacked-100-area") && typeof ChartjsPluginStacked100 !== "undefined" ? { enable: true, precision: 1 } : undefined
                },
                scales: {}
            }
        };

        // Set aspectRatio only if we have a valid value
        const hasValidAspectRatio = aspectRatioValue !== null && aspectRatioValue !== undefined && !isNaN(aspectRatioValue) && aspectRatioValue > 0;
        if (hasValidAspectRatio) {
            config.options.aspectRatio = aspectRatioValue;
            config.options.maintainAspectRatio = true;
            // Add class to container to remove min-height
            $graph.closest('.graph-preview-container').addClass('has-aspect-ratio');
        }

        const isHorizontalBar = (Utils.isHorizontalBar && Utils.isHorizontalBar(chartType)) || (chartType === "bar" || chartType === "stacked-bar" || chartType === "stacked-100-bar");

        if (type === "bar" && isHorizontalBar) {
            config.options.indexAxis = "y";
        }

        if (type !== "pie" && type !== "wordcloud" && type !== "wordCloud") {
            config.options.scales.x = {
                display: true,
                title: { display: !!xAxisLabel, text: xAxisLabel },
                min: parseAxisValue(xAxisMin),
                max: parseAxisValue(xAxisMax),
                stacked: isStacked,
                grid: { display: showGrid }
            };
            config.options.scales.y = {
                display: true,
                title: { display: !!yAxisLabel, text: yAxisLabel },
                min: parseAxisValue(yAxisMin),
                max: parseAxisValue(yAxisMax),
                stacked: isStacked,
                grid: { display: showGrid }
            };
        }

        // Create chart
        graphDynamic[index] = new Chart($graph[0], config);
    }

    // Download chart as image
    $(document).off("click", ".download-chart-image").on("click", ".download-chart-image", function () {
        const $button = $(this);
        const $canvas = $button.closest(".position-relative").find("canvas.graph-piece");

        if (!$canvas.length) return;

        const chart = Chart.getChart($canvas[0]);
        if (!chart) {
            Swal.fire({ icon: "warning", title: "Uyarı", text: "Grafik henüz yüklenmedi.", timer: 2000 });
            return;
        }

        try {
            const url = chart.toBase64Image();
            const link = document.createElement("a");
            link.download = "grafik_" + new Date().getTime() + ".png";
            link.href = url;
            link.click();
        } catch (e) {
            console.error("Error downloading chart image:", e);
            Swal.fire({ icon: "error", title: "Hata", text: "Grafik indirilemedi.", timer: 2000 });
        }
    });

    // Download chart data as CSV
    $(document).off("click", ".download-chart-data").on("click", ".download-chart-data", function () {
        const data = $(this).data("data");
        if (!data || !Array.isArray(data) || data.length === 0) {
            Swal.fire({ icon: "warning", title: "Uyarı", text: "İndirilecek veri yok.", timer: 2000 });
            return;
        }

        try {
            let csv = "";
            data.forEach((row) => {
                const csvRow = row.map(cell => {
                    const cellValue = cell || "";
                    if (cellValue.toString().includes(",") || cellValue.toString().includes('"') || cellValue.toString().includes("\n")) {
                        return '"' + cellValue.toString().replace(/"/g, '""') + '"';
                    }
                    return cellValue;
                }).join(",");
                csv += csvRow + "\n";
            });

            const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
            const link = document.createElement("a");
            link.download = "veri_" + new Date().getTime() + ".csv";
            link.href = URL.createObjectURL(blob);
            link.click();
            URL.revokeObjectURL(link.href);
        } catch (e) {
            console.error("Error downloading chart data:", e);
            Swal.fire({ icon: "error", title: "Hata", text: "Veri indirilemedi.", timer: 2000 });
        }
    });

    /* ============================================
       Color Utility Functions
       ============================================ */
    function invertHex(hex, bw) {
        if (hex.indexOf('#') === 0) {
            hex = hex.slice(1);
        }
        if (hex.length === 3) {
            hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
        }
        if (hex.length !== 6) {
            throw new Error('Invalid HEX color.');
        }
        var r = parseInt(hex.slice(0, 2), 16),
            g = parseInt(hex.slice(2, 4), 16),
            b = parseInt(hex.slice(4, 6), 16);
        if (bw) {
            return (r * 0.299 + g * 0.587 + b * 0.114) > 186
                ? '#000000'
                : '#FFFFFF';
        }
        r = (255 - r).toString(16);
        g = (255 - g).toString(16);
        b = (255 - b).toString(16);
        return "#" + padZero(r) + padZero(g) + padZero(b);
    }

    function padZero(str, len) {
        len = len || 2;
        var zeros = new Array(len).join('0');
        return (zeros + str).slice(-len);
    }

    /* ============================================
       Currency Management
       ============================================ */
    function setCurrency(currency) {
        localStorage.setItem('selectedCurrency', currency);
        const url = new URL(window.location);
        url.searchParams.set('c', currency);
        window.location.href = url.toString();
    }

    function getStoredCurrency() {
        return localStorage.getItem('selectedCurrency') || 'TL';
    }

    function initializeCurrency() {
        var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
        var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
            return new bootstrap.Tooltip(tooltipTriggerEl);
        });

        const storedCurrency = getStoredCurrency();
        const urlParams = new URLSearchParams(window.location.search);

        if (storedCurrency && storedCurrency !== 'TL' && !urlParams.has('c')) {
            setCurrency(storedCurrency);
        }

        $('.dropdown-item[href*="?c="]').on('click', function (e) {
            e.preventDefault();
            const href = $(this).attr('href');
            const currency = href.split('?c=')[1];
            setCurrency(currency);
        });
    }

    /* ============================================
       Form Handler
       ============================================ */
    function init() {
        let ajaxOptions = {
            beforeSerialize: function ($form, options) { },
            beforeSubmit: function (arr, $form, options) {
                $("#loader .progress-bar").css("width", "0%").html("");
                $("#loader .transfer-progress").html("");
                $("#loader").show();
            },
            uploadProgress: function (event, position, total, percentComplete) {
                $("#loader .progress-bar")
                    .css("width", percentComplete + "%")
                    .html("% " + percentComplete);
                if (total > FILE_SIZE_THRESHOLD) {
                    $("#loader .transfer-progress").html(
                        fileSizeNice(position) + "/" + fileSizeNice(total)
                    );
                }
            },
            success: function (resp) {
                history.replaceState(null, null, " ");
                if (resp) {
                    if (resp.hasOwnProperty("hash")) {
                        window.location.hash = resp.hash;
                    }
                    if (resp.hasOwnProperty("status")) {
                        $("#loader").hide();
                        Swal.fire({
                            icon: resp.status,
                            title: resp.title,
                            html: resp.body ? resp.body : null,
                            timer: resp.timer ? resp.timer : false,
                            timerProgressBar: true,
                            confirmButtonText: resp.button ? resp.button : "OK",
                            didOpen: (s) => {
                                s.addEventListener("mouseenter", Swal.stopTimer);
                                s.addEventListener("mouseleave", Swal.resumeTimer);
                            },
                        }).then(function () {
                            if (resp.hasOwnProperty("destination")) {
                                window.location.href = resp.destination;
                            } else if (resp.hasOwnProperty("refresh")) {
                                location.reload();
                            }
                        });
                    } else if (resp.hasOwnProperty("destination")) {
                        window.location.href = resp.destination;
                    } else if (resp.hasOwnProperty("refresh")) {
                        location.reload();
                    }
                } else {
                    location.reload();
                }
            },
            error: function (e) {
                $("#loader").hide();
                Swal.fire(
                    "Hata",
                    "Bir hata oluştu, tekrar deneyiniz.",
                    "error"
                );
            }
        };

        $('form[data-toggle="validator"]')
            .attr("novalidate", true)
            .off("submit")
            .on("submit", function (e) {
                let form = $(this);
                if (form[0].checkValidity() === false) {
                    e.preventDefault();
                    e.stopPropagation();
                    Swal.fire(
                        strings.warning,
                        strings.checkRedMarkedFields,
                        "warning"
                    );
                    form.addClass("was-validated");
                }
            });

        $(".dynamic").ajaxFormUnbind();
        $(".dynamic").ajaxForm(ajaxOptions);

        $('iframe.h-dyn').each(function (index, el) {
            $(el).ready(function () {
                const updateHeight = () => {
                    el.style.height = el.contentWindow.document.body.scrollHeight + 25 + 'px';
                };
                setTimeout(updateHeight, 100);
                setTimeout(updateHeight, 500);
                setTimeout(updateHeight, 2000);
            });
        });

        selectPickerInit();
        dtPickerInit();

        setTimeout(() => {
            $('[data-bs-toggle="tooltip"]').tooltip({
                html: true,
                container: 'body'
            });
            $('[data-bs-toggle="popover"]').popover({
                trigger: "focus",
                html: true,
                placement: "top",
            });
        }, TOOLTIP_DELAY);
    }

    /**
     * Extract options array from various response formats
     */
    function extractOptionsFromResponse(response) {
        if (Array.isArray(response)) return response;
        if (response?.data && Array.isArray(response.data)) return response.data;
        if (response?.results && Array.isArray(response.results)) return response.results;
        return [];
    }

    /**
     * Map option item to selectpicker format
     */
    function mapOptionItem(item) {
        if (typeof item === 'string') {
            return { text: item, value: item };
        }
        if (typeof item !== 'object') return item;

        return {
            text: item.text || item.name || item.label || item.value || '',
            value: item.value || item.id || item.text || ''
        };
    }

    /**
     * Initialize a single selectpicker with AJAX support
     */
    function initSelectPicker($select) {
        const ajaxUrl = $select.attr("data-ajax-url") || $select.attr("data-abs-ajax-url");

        if (!ajaxUrl) {
            // If already initialized, just refresh; otherwise initialize
            if ($select.data('selectpicker')) {
                $select.selectpicker('refresh');
            } else {
                $select.selectpicker({
                    selectAllText: strings.selectAllText,
                    deselectAllText: strings.deselectAllText,
                });
            }
            return;
        }

        // Destroy existing selectpicker if it exists to ensure clean re-initialization with AJAX
        // Preserve selected value before destroying
        let preservedValue = null;
        if ($select.data('selectpicker')) {
            preservedValue = $select.selectpicker('val');
            $select.selectpicker('destroy');
        } else {
            // For fresh initialization, check if there's a selected option in the HTML
            const selectedOption = $select.find('option[selected]');
            if (selectedOption.length > 0) {
                preservedValue = selectedOption.val();
            }
        }

        // Collect data-* attributes (excluding internal ones)
        const dataParams = {};
        $.each($select[0].attributes, (index, attribute) => {
            if (/^data-/.test(attribute.name)) {
                const key = attribute.name.substring(5);
                // Skip internal attributes
                if (key !== 'abs-ajax-url' && key !== 'ajax-url') {
                    dataParams[key] = attribute.value;
                }
            }
        });

        let isInitialLoad = true;

        const makeAjaxRequest = (callback, searchValue) => {
            const params = { ...dataParams };
            if (searchValue) params.q = searchValue;

            $.ajax({
                url: ajaxUrl,
                method: "POST",
                data: params,
                success: (response) => {
                    const options = extractOptionsFromResponse(response).map(item => mapOptionItem(item));
                    const hasMore = response?.hasMore || false;
                    const totalItems = response?.total || options.length;
                    callback(options, hasMore, totalItems);

                    // After initial load, set preserved value if it exists
                    if (isInitialLoad && preservedValue !== null && preservedValue !== '') {
                        isInitialLoad = false;
                        // Use setTimeout to ensure selectpicker has processed the options
                        setTimeout(() => {
                            $select.selectpicker('val', preservedValue);
                        }, 100);
                    } else if (isInitialLoad) {
                        isInitialLoad = false;
                    }
                },
                error: () => {
                    callback([], false, 0);
                    if (isInitialLoad) {
                        isInitialLoad = false;
                    }
                }
            });
        };

        $select.selectpicker({
            selectAllText: strings.selectAllText,
            deselectAllText: strings.deselectAllText,
            source: {
                data: (callback, page, searchValue) => makeAjaxRequest(callback, searchValue),
                search: (callback, page, searchValue) => makeAjaxRequest(callback, searchValue)
            }
        });

        // Fallback: if preserved value exists but initial load doesn't set it, try after a delay
        if (preservedValue !== null && preservedValue !== '') {
            setTimeout(() => {
                const currentVal = $select.selectpicker('val');
                if (!currentVal || currentVal === '') {
                    $select.selectpicker('val', preservedValue);
                }
            }, 500);
        }
    }

    /**
     * Initialize Bootstrap Select
     */
    function selectPickerInit() {
        $(".selectpicker").each(function () {
            const $select = $(this);

            // Skip if already initialized (unless it has AJAX that needs re-initialization)
            const hasAjaxUrl = !!($select.attr('data-ajax-url') || $select.attr('data-abs-ajax-url'));

            if ($select.data('selectpicker') && !hasAjaxUrl) {
                return;
            }

            initSelectPicker($select);
        });
    }

    function dtPickerInit() {
        $(".dtpicker").each(function () {
            let $this = $(this);
            $this.datetimepicker({
                format: $this.data("format"),
                minDate: $this.data("min-date") ? $this.data("min-date") : false,
                maxDate: $this.data("max-date") ? $this.data("max-date") : false,
                viewMode: $this.data("view-mode") ? $this.data("view-mode") : "days",
                focusOnShow: false,
                ignoreReadonly: true,
                useCurrent: false,
                showTodayButton: true,
                showClear: true,
                showClose: true,
                debug: false,
                locale: strings.userLocale,
            });
        });

        $("[data-linked-min]").off("dp.change").on("dp.change", function (e) {
            $("[name=" + $(this).attr("data-linked-min") + "]").data("DateTimePicker").minDate(e.date);
        });

        $("[data-linked-max]").off("dp.change").on("dp.change", function (e) {
            $("[name=" + $(this).attr("data-linked-max") + "]").data("DateTimePicker").maxDate(e.date);
        });
    }

    /* ============================================
       Favorites Management
       ============================================ */
    function initializeFavorites() {
        // Check favorite status on page load
        $(".favorite-btn").each(function () {
            let $btn = $(this);
            let reportId = $btn.data("report-id");
            let sectionId = $btn.data("section-id");

            if (!reportId) return;

            let payload = { report_id: reportId };
            if (sectionId) {
                payload.section_id = sectionId;
            }

            $.ajax({
                method: "POST",
                url: "/a/clientActions/checkFavorite",
                data: payload,
                dataType: "json"
            })
                .done(function (response) {
                    if (response && response.is_favorite) {
                        $btn.find("i").removeClass("bi-heart").addClass("bi-heart-fill");
                        $btn.addClass("text-danger");
                        $btn.attr("data-bs-original-title", "Favorilerden Kaldır");
                    } else {
                        $btn.find("i").removeClass("bi-heart-fill").addClass("bi-heart");
                        $btn.removeClass("text-danger");
                        $btn.attr("data-bs-original-title", "Favorilere Ekle");
                    }
                    // Reinitialize tooltip
                    if ($btn.data("bs.tooltip")) {
                        $btn.tooltip("dispose");
                    }
                    $btn.tooltip();
                })
                .fail(function () {
                    // Silently fail - user might not be logged in
                });
        });

        // Handle favorite button clicks
        $(document).on("click", ".favorite-btn", function (e) {
            e.preventDefault();
            e.stopPropagation();

            let $btn = $(this);
            let reportId = $btn.data("report-id");
            let sectionId = $btn.data("section-id");

            if (!reportId) return;

            let payload = { report_id: reportId };
            if (sectionId) {
                payload.section_id = sectionId;
            }

            // Disable button during request
            $btn.prop("disabled", true);

            $.ajax({
                method: "POST",
                url: "/a/clientActions/toggleFavorite",
                data: payload,
                dataType: "json"
            })
                .done(function (response) {
                    if (response && response.status === "success") {
                        // Update button state
                        if (response.is_favorite) {
                            $btn.find("i").removeClass("bi-heart").addClass("bi-heart-fill");
                            $btn.addClass("text-danger");
                            $btn.attr("data-bs-original-title", "Favorilerden Kaldır");
                        } else {
                            $btn.find("i").removeClass("bi-heart-fill").addClass("bi-heart");
                            $btn.removeClass("text-danger");
                            $btn.attr("data-bs-original-title", "Favorilere Ekle");
                        }

                        // Reinitialize tooltip
                        if ($btn.data("bs.tooltip")) {
                            $btn.tooltip("dispose");
                        }
                        $btn.tooltip();

                        // Show notification
                        if (response.title && response.body) {
                            Swal.fire({
                                icon: response.status,
                                title: response.title,
                                html: response.body,
                                timer: response.timer || 2000,
                                timerProgressBar: true,
                                showConfirmButton: false,
                                didOpen: (s) => {
                                    s.addEventListener("mouseenter", Swal.stopTimer);
                                    s.addEventListener("mouseleave", Swal.resumeTimer);
                                }
                            });
                        }

                        // If on favorites page, reload to update list
                        if (window.location.pathname === "/favorites") {
                            setTimeout(function () {
                                location.reload();
                            }, response.timer || 2000);
                        }
                    } else {
                        Swal.fire({
                            icon: "error",
                            title: response.title || "Hata",
                            text: response.body || "Bir hata oluştu, lütfen tekrar deneyiniz."
                        });
                    }
                })
                .fail(function (xhr) {
                    let errorMsg = "Bir hata oluştu, lütfen tekrar deneyiniz.";
                    try {
                        let response = JSON.parse(xhr.responseText);
                        if (response.body) {
                            errorMsg = response.body;
                        }
                    } catch (e) {
                        // Use default error message
                    }
                    Swal.fire({
                        icon: "error",
                        title: "Hata",
                        text: errorMsg
                    });
                })
                .always(function () {
                    $btn.prop("disabled", false);
                });
        });
    }

    /* ============================================
       Main Initialization
       ============================================ */
    $(document).ready(function () {
        initializeDOM();
        initializeModals();
        initializeActionEndpoints();
        initializeFormValidation();
        initializeOnPageSearch();
        initializeReportMenu();
        initializeGraphs();
        initializeCurrency();
        initializeFavorites();
        init();
    });

    // Expose utility functions globally
    window.fileSizeNice = fileSizeNice;
    window.isJson = isJson;
    window.throttle = throttle;
    window.debounce = debounce;
    window.invertHex = invertHex;
    window.padZero = padZero;

})(jQuery);
